import { combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import {
  catchError,
  filter,
  groupBy,
  map,
  mergeMap,
  startWith,
  throttleTime,
} from 'rxjs/operators';
import { requestActions } from './apiHelpers';
import { AppState } from '@reducers/rootReducer';
import { ID, ReduxAction } from '../types';
import { Moments } from '@models/Moments';
import { apiObservable } from '@support/api';

/* Epic actions */
const momentsActions = requestActions('MOMENTS', ['fetch']);

/* Selectors */
export const interactionsSelector = (contactID: ID) => (state: AppState) =>
  state.data.moments.collection.items.get(String(contactID), new Moments()).interactions;

export const summarySelector = (contactID: ID) => (state: AppState) =>
  state.data.moments.collection.items.get(String(contactID), new Moments()).summary;

/* Epics */
// Request every time contact is being fetched, throttled to <= 60 seconds by contact ID
export const fetchMomentsEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('SELECT_CONTACT'),
    filter(({ payload }) => !!payload?.contact),
    groupBy(({ payload }) => payload.contact.id),
    mergeMap((fetchesByID) =>
      fetchesByID.pipe(
        // For a given contact, only fetch the cadence at most once every 1 minute
        throttleTime(1000 * 60 * 1),
        mergeMap(({ payload }) =>
          apiObservable('GET', `/network/contacts/${payload.contact.id}/interactions/summary`).pipe(
            map((response) => {
              return momentsActions['fetchSucceeded']({
                ...response,
                requestID: payload.contact.id,
              });
            }),
            startWith(momentsActions['fetchRequested'](payload.contact)),
            catchError((err) => of(momentsActions['fetchFailed'](err))),
          ),
        ),
      ),
    ),
  );

export const momentsEpic = combineEpics(fetchMomentsEpic);
